import { i18n as linguiI18n } from '@lingui/core'
import { catalogs } from './locales/catalogs'
import { getLanguage } from '@utils/language'

const initI18n = () => {
  const language = getLanguage()
  linguiI18n.load(catalogs)
  linguiI18n.activate(language)
}

initI18n()

export const i18n = linguiI18n
